import { render, staticRenderFns } from "./ProductViewRelatedProducts.vue?vue&type=template&id=4423d24e&scoped=true&"
import script from "./ProductViewRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./ProductViewRelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewRelatedProducts.vue?vue&type=style&index=0&id=4423d24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423d24e",
  null
  
)

export default component.exports